import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService";

class AuthPatientService extends AxiosService {
  constructor() {
    super("auth/patients");
  }

  /**
   * Retrieves all data from a patient.
   * Response shape: `{ data: { profile: {}, userData: {}, auth: {}, anomalies: [] } }`
   *
   * @param {string} patientId - Patient auth_user_id
   * @returns {Promise<import("axios").AxiosResponse>}
   */
  getPatientCompleteInfo = async (patientId) => {
    const base = `/management/info/${patientId}`;
    return await this.get(base, {
      headers: { Authorization: `Bearer ${this.getToken()}` },
    });
  };


  /**
   * Updates a patient email.
   *
   * @param {string} patientId - Patient auth_user_id
   * @param {string} newEmail - Patient new email
   * @returns {Promise<import("axios").AxiosResponse>}
   */
  updatePatientEmail = async (patientId, newEmail) => {
    const base = `/management/info/${patientId}/email`;
    return await this.post(base, {email: newEmail}, {
      headers: { Authorization: `Bearer ${this.getToken()}` },
    });
  };

}

export default new AuthPatientService();